module.exports = __webpack_public_path__ + "img/Bet_Key.71be5089.svg";